if (!customElements.get('team-modal')) {
  customElements.define(
    'team-modal',
    class TeamModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="TeamInfo-"]');
        this.titleElement = null;
        this.subtitleElement = null;
        this.contentElement = null;
        this.linkedinElement = null;
        
        // Get attributes
        this.teamId = this.getAttribute('team-id');
        this.title = this.getAttribute('data-title') || '';
        this.text = this.getAttribute('data-text') || '';
        this.teamContents = this.getAttribute('data-team-contents') || '';
        this.linkedinLink = this.getAttribute('data-linkedin-link') || '';
        this.image = this.getAttribute('data-image') || '';
      }

      show(opener) {
        // Create modal content if it doesn't exist
        if (!this.modalContent) {
          this.createModalContent();
        }

        // Update content
        this.updateContent();

        // Show the modal
        super.show(opener);
      }

      createModalContent() {
        // Create the modal content structure
        const contentHTML = `
          <div role="dialog" 
               aria-label="Team Member" 
               aria-modal="true" 
               id="TeamInfo-${this.teamId || 'default'}"
               class="team-modal__content popup-modal__content custom-scrollbar" 
               tabindex="-1">
            <button id="ModalClose-${this.teamId || 'default'}" 
                    type="button" 
                    class="quick-add-modal__toggle tap-target button-control" 
                    aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            
            <div class="team-modal__body">
              <img src="${this.image || ''}" alt="${this.title || ''}" width="400" height="448" loading="lazy" fetchpriority="low">
              <h2 class="section-title h4" id="TeamModalTitle-${this.teamId || 'default'}"></h2>
              <div class="team-modal__text rte inline-block" style="${this.text ? '' : 'display: none;'}"></div>
              <div class="team-modal__linkedin" style="${this.linkedinLink ? '' : 'display: none;'}">
                <a href="${this.linkedinLink || '#'}" target="_blank" rel="noopener noreferrer" class="team-modal__linkedin-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .771 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .771 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
              <div class="team-modal__contents rte" style="${this.teamContents ? '' : 'display: none;'}"></div>
            </div>
          </div>
        `;

        this.innerHTML = contentHTML;
        this.modalContent = this.querySelector('[id^="TeamInfo-"]');
        this.titleElement = this.querySelector('[id^="TeamModalTitle-"]');
        this.contentElement = this.querySelector('.team-modal__body');
      }

      updateContent() {
        // Update title
        if (this.titleElement) {
          this.titleElement.textContent = this.title;
        }

        // Update image if exists
        const imageContainer = this.querySelector('.team-modal__image');
        const imageElement = this.querySelector('.team-modal__image img');
        if (imageContainer && imageElement) {
          if (this.image) {
            imageContainer.style.display = '';
            imageElement.src = this.image;
            imageElement.alt = this.title || '';
          } else {
            imageContainer.style.display = 'none';
          }
        }

        // Update text content
        const textElement = this.querySelector('.team-modal__text');
        if (textElement) {
          if (this.text) {
            textElement.style.display = '';
            textElement.innerHTML = this.text;
          } else {
            textElement.style.display = 'none';
          }
        }

        // Update team contents
        const contentsElement = this.querySelector('.team-modal__contents');
        if (contentsElement) {
          if (this.teamContents) {
            contentsElement.style.display = '';
            contentsElement.innerHTML = this.teamContents;
          } else {
            contentsElement.style.display = 'none';
          }
        }

        // Update LinkedIn link
        const linkedinContainer = this.querySelector('.team-modal__linkedin');
        const linkedinLinkElement = this.querySelector('.team-modal__linkedin-link');
        if (linkedinContainer && linkedinLinkElement) {
          if (this.linkedinLink) {
            linkedinContainer.style.display = '';
            linkedinLinkElement.href = this.linkedinLink;
          } else {
            linkedinContainer.style.display = 'none';
          }
        }
      }

      // Method to update team data dynamically
      updateTeamData(data) {
        if (data.title) {
          this.title = data.title;
          this.setAttribute('data-title', data.title);
        }
        if (data.text) {
          this.text = data.text;
          this.setAttribute('data-text', data.text);
        }
        if (data.teamContents) {
          this.teamContents = data.teamContents;
          this.setAttribute('data-team-contents', data.teamContents);
        }
        if (data.linkedinLink) {
          this.linkedinLink = data.linkedinLink;
          this.setAttribute('data-linkedin-link', data.linkedinLink);
        }
        if (data.image) {
          this.image = data.image;
          this.setAttribute('data-image', data.image);
        }
        this.updateContent();
      }
    }
  );
}

